import { FUND_LIST, FUND_ADDEDIT, FUND_WOP_LIST, FUND_CHANGE_STATUS, FUND_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const fundListApi = (payload) => {
    return apiInstance.post(FUND_LIST, payload, {
        headers: authHeader(),
    });
};

export const fundChangeStatusApi = (payload) => {
    return apiInstance.post(FUND_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditFundApi = (payload) => {
    return apiInstance.post(FUND_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const fundWopListApi = (payload) => {
    return apiInstance.get(FUND_WOP_LIST, {
        headers: authHeader(),
        params: payload
    });
};  

export const fundDeleteApi = (payload) => {
    return apiInstance.post(FUND_DELETE, payload, {
        headers: authHeader(),
    });
};